import { defineStore } from 'pinia'

export const useUserStore = defineStore('userObject', {
  state: () => ({ obj: {} }),
  getters: {
    get: (state) => state.obj,
  },
  actions: {
    set(value) { this.obj = value },
  },
})